import { Tooltip } from "@mui/material";
import { memo } from "react";

function SkuDescricao(props: any) {
  const { value } = props;
  
  return (
    <>
      <Tooltip title={value}>
          <span style={{ whiteSpace: 'normal', textAlign: 'left'}}>{value}</span>
        </Tooltip>
    </>
  );
}

export default memo(SkuDescricao);
